import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { Container, Row, Column, Badge } from '@pella/sash-framework';

import ScheduleConsultation from '../../page/rta/v3/home';

const RTAPanel = ({ data, className, boxBg = '!bg-neutral-50', src, ...other }) => {
	const configData = useStaticQuery(query).contentstackGlobalConfig?.rta;

	return (
		<div
			id={data?.anchor_text}
			className={`rtaPanel ${className || ''}`}
			{...other}
		>
			<Container>
				<Row
					align='center'
					largeGutters
					verticalGutters
				>
					<Column
						xs={12}
						md='fluid'
					>
						{configData?.heading && (
							<div className='mb-2 md:flex md:items-start xl:mb-3'>
								{data?.step && (
									<Badge
										{...(data.$?.step ?? {})}
										color='primary'
										className='mb-2.5 mr-4 border-0 text-xs font-normal md:mb-0 md:mt-1 md:flex-none md:text-sm xl:mt-0.5 xl:text-base'
									>
										{data.step}
									</Badge>
								)}
								<h2
									{...(data?.$?.heading ?? {})}
									className='m-0 text-22px md:flex-1 md:text-28px'
									dangerouslySetInnerHTML={{ __html: data?.heading || configData.heading }}
								/>
							</div>
						)}

						{configData?.subheading && (
							<div
								className='font-semibold uppercase !leading-tight tracking-1px text-neutral-600 [&_p]:flex [&_p]:items-center [&_span]:mr-2'
								dangerouslySetInnerHTML={{ __html: configData.subheading }}
							/>
						)}

						{configData?.description && (
							<div
								className='mt-3 md:mt-4 md:text-base xl:text-xl [&_ul]:mt-6 xl:[&_ul]:mt-8'
								dangerouslySetInnerHTML={{ __html: data?.description || configData.description }}
							/>
						)}
					</Column>

					<Column
						xs={12}
						md={6}
					>
						<ScheduleConsultation
							renderAs='form-only'
							src={src}
						/>
					</Column>
				</Row>
			</Container>
		</div>
	);
};

RTAPanel.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
	boxBg: PropTypes.string,
	src: PropTypes.string,
};

export default RTAPanel;

export const query = graphql`
	query {
		contentstackGlobalConfig {
			rta {
				heading
				subheading
				description
			}
		}
	}
`;
